module.exports = __webpack_public_path__ + "static/media/completed.bc327636.svg";